const TINYSLIDER = {
    onReady() {
        TINYSLIDER.slider();
    },
    slider() {
        if (document.querySelector('.js-tiny-slider') === null) return;
        let sliders = document.querySelectorAll('.js-tiny-slider__slides');
        sliders.forEach(slider => {
            let controlsContainer = slider.parentNode.querySelector('.js-tiny-slider__controls');
            let dotsContainer     = slider.parentNode.querySelector('.js-tiny-slider__dots');
            let tinySlider = tns({
                container: slider,
                controlsContainer: controlsContainer,
                navContainer: dotsContainer,
                mode: 'carousel',
                loop: true,
                items: 1,
                mouseDrag: true,
                autoWidth: false,
                center: true,
                speed: 750,
                autoHeight: true,
                preventScrollOnTouch: 'auto'
            });
        })
    }
}